import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/[slug]/ArticleActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/[slug]/ArticleComments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/[slug]/ReaderAiTools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/[slug]/ReadingProgress.tsx");
